module.exports = __webpack_public_path__ + "img/startBattery_online.b0687386.png";